export type ProductBarcode = { value: string; type: string | null };
/** Extra Shopify identifiers. The first identifier remains in the legacy barcode field. */
export function additionalBarcodes(product: unknown): string[] {
  if (!product || typeof product !== 'object' || !('barcodes' in product)) return [];
  try {
    const values = typeof product.barcodes === 'string' ? JSON.parse(product.barcodes) : product.barcodes;
    if (!Array.isArray(values)) return [];
    return values.flatMap(value => value && typeof value.value === 'string' && value.value.length > 0 && value.value.length <= 255 ? [value.value] : []);
  } catch { return []; }
}
